/**
 * The one place this library decides whether a caller-supplied address is safe
 * to put in an `href`.
 *
 * A URL that reaches us from a provider record is data, not markup, and a
 * `javascript:` (or `data:`, or `vbscript:`) value in an `href` EXECUTES on
 * click. Nothing upstream guarantees a scheme: `link_external_work_refs.url` is
 * unbounded Postgres text written from a connector's response.
 *
 * Only absolute `http:` and `https:` pass. A relative path is rejected too — a
 * component rendering an EXTERNAL link has no base to resolve one against, and
 * accepting it would silently produce a link into our own app.
 *
 * Returns `null` for anything else, so a caller renders plain text rather than a
 * link. Never throws, and never rewrites: a repaired URL would be a guess about
 * where someone meant to go.
 */
export function safeExternalHref(
  url: string | null | undefined,
): string | null {
  if (url === null || url === undefined || url === "") return null;
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    return null;
  }
  return parsed.protocol === "http:" || parsed.protocol === "https:"
    ? url
    : null;
}
